import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';

const useSendPasswordReset = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null)

    const sendPasswordReset = async ({email}) => {

        setLoading(true)
        setError(null)
        setResponse(null)

        try {
            const res = await postEmail('/password-reset/request', { email });
            setResponse(res.data.message)

        } catch (err) {
            setError(getApiErrorMessage(err, 'Não foi possível enviar o e-mail. Tente novamente.'));
        } finally {
            setLoading(false);
        }
    };
    return { sendPasswordReset, response, loading, error };
}

export default useSendPasswordReset
